import type {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';

import { get, post } from './api';

export const getTicketsReportLastMonthApi = async (
  params?: GetTicketsReportLastMonthParamsDTO
): Promise<GetTicketsReportLastMonthResponseDTO> => {
  const response = await get<GetTicketsReportLastMonthResponseDTO>(
    '/ticket-reports/last-month',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO params are serializable by Axios
    params as any
  );

  return response.data;
};

export const getClaimReportCardsApi = async (
  params?: GetClaimReportParamsDTO
): Promise<GetClaimReportsResponseDTO> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO params are serializable by Axios
  const response = await get<{ reportCards: GetClaimReportsResponseDTO }>(
    '/invoice-reports/report-cards',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO params are serializable by Axios
    params as any
  );

  return response.data.reportCards;
};

export const postTicketsReportScheduleApi = async (
  params?: GetTicketsReportScheduleParamsDTO
): Promise<GetTicketsReportScheduleResponseDTO> => {
  const response = await post<GetTicketsReportScheduleResponseDTO>(
    '/ticket-reports/schedule',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO params are serializable by Axios
    params as any
  );

  return response.data;
};
